exports.Bump = require('./src/bump').Bump;
